import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "habitalys_cookie_consent";

export const CookieBanner = () => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    setOpen(!localStorage.getItem(KEY));
    const reopen = () => setOpen(true);
    window.addEventListener("habitalys:cookies", reopen);
    return () => window.removeEventListener("habitalys:cookies", reopen);
  }, []);
  const choose = (v) => { localStorage.setItem(KEY, JSON.stringify({ choice: v, at: new Date().toISOString() })); setOpen(false); };
  if (!open) return null;
  return (
    <div role="dialog" aria-live="polite" aria-label="Gestion des cookies" data-testid="cookie-consent-banner"
      className="fixed inset-x-3 bottom-3 md:inset-x-auto md:right-6 md:bottom-6 md:max-w-md z-[60] rounded-3xl glass !bg-white/90 p-6 rise">
      <div className="flex gap-3 items-start">
        <span className="h-10 w-10 rounded-xl bg-brand-100 text-brand-ink flex items-center justify-center shrink-0"><Cookie className="h-5 w-5" aria-hidden="true" /></span>
        <div>
          <h2 className="text-lg">Cookies</h2>
          <p className="text-[15px] text-slate-700 mt-1">Uniquement les traceurs nécessaires, sauf accord de votre part pour une mesure d'audience anonyme. <Link to="/cookies" className="link-u text-navy font-semibold">En savoir plus</Link></p>
        </div>
      </div>
      <div className="mt-5 flex gap-3">
        <button type="button" className="btn-outline flex-1 py-2.5" onClick={() => choose("refused")} data-testid="cookie-refuse-button">Tout refuser</button>
        <button type="button" className="btn-primary flex-1 py-2.5" onClick={() => choose("accepted")} data-testid="cookie-accept-button">Tout accepter</button>
      </div>
    </div>
  );
};
